"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDateOfBirthConfirmationMachine = exports.getInitialContext = void 0;
const xstate_1 = require("xstate");
const States_1 = require("../../../lib/constants/States");
const actions_dobConfirmationMachine_1 = __importStar(require("./actions.dobConfirmationMachine"));
const guards_dobConfirmationMachine_1 = __importStar(require("./guards.dobConfirmationMachine"));
const Events_1 = require("../../../lib/constants/Events");
const getInitialContext = () => ({
    waitlist: undefined,
    provider: undefined,
    dateOfBirth: undefined
});
exports.getInitialContext = getInitialContext;
const createDateOfBirthConfirmationMachine = (initialContext = (0, exports.getInitialContext)()) => (0, xstate_1.createMachine)({
    id: 'confirmationMachine',
    initial: States_1.states.idle,
    context: initialContext,
    states: {
        [States_1.states.idle]: {
            on: {
                [Events_1.VALIDATE_DATE]: {
                    target: States_1.states.validating,
                    actions: actions_dobConfirmationMachine_1.setDateOfBirth
                }
            }
        },
        [States_1.states.validating]: {
            always: [
                {
                    target: States_1.states.validateSuccess,
                    cond: guards_dobConfirmationMachine_1.isDateOfBirthValid
                },
                {
                    target: States_1.states.validateFailure
                }
            ]
        },
        [States_1.states.validateSuccess]: {
            entry: [actions_dobConfirmationMachine_1.sendValidatedDateOfBirth]
        },
        [States_1.states.validateFailure]: {
            on: {
                [Events_1.VALIDATE_DATE]: {
                    target: States_1.states.validating,
                    actions: actions_dobConfirmationMachine_1.setDateOfBirth
                }
            }
        }
    }
}, {
    actions: actions_dobConfirmationMachine_1.default,
    guards: guards_dobConfirmationMachine_1.default,
    services: {}
});
exports.createDateOfBirthConfirmationMachine = createDateOfBirthConfirmationMachine;
//# sourceMappingURL=dobConfirmationMachine.js.map